import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import DashboardModalView from "./routes/DashboardModalView";

export default store => {
  return {
    path: "pinned-dashboards-playground",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "pinned-dashboards" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [DashboardModalView(store)],
  };
};
